import { useParams as u } from "@tanstack/react-router";
import { useConfig as m } from "./use-config.js";
import { getRoutePathById as f } from "../utils/get-route-path-by-id.js";
const n = (t) => /^[a-z\-0-9]*:\/\//i.test(t), p = (t) => t.startsWith("/") ? t : `/${t}`, g = (t, r) => t.startsWith(`/${r}/`), e = (t, r) => {
  const s = p(t);
  return g(s, r) ? s : `/${r}${s}`;
}, L = (t, r, s) => {
  if (t) {
    if (typeof t == "string")
      return n(t) ? { to: t } : { to: e(t, r) };
    if (t.id) {
      const o = f({ id: t.id, pages: s, lang: r }) || "";
      return {
        to: e(o, r),
        params: { ...t.params, lang: r }
      };
    }
    return t.href ? {
      to: e(t.href, r),
      params: { ...t.params, lang: r }
    } : t;
  }
}, $ = ({
  href: t,
  onClick: r,
  target: s
}) => {
  const { lang: o } = u({ strict: !1 }), { pages: i } = m(), c = L(t, o, i), a = typeof t == "string" && n(t);
  return {
    linkItem: c,
    isExternal: a,
    target: !s && a ? "_blank" : s,
    onClick: r
  };
};
export {
  $ as useLink
};
